var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'calendar-button': true, 'active': _vm.openMenu },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"calendar-button__icon"},[_c('icon-calendar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }